module.exports = __webpack_public_path__ + "assets/img/2271591947409_.pic_hd.fcc87fef.jpg";